var link_viewer_wrapper_default = {
  "anchor": "lrdwu",
  "link": "jDOio"
};
export {
  link_viewer_wrapper_default as default
};
//# sourceMappingURL=link-viewer-wrapper-scss.js.map
